export default "__VITE_ASSET__D22Zzi8R__"